export default __webpack_public_path__ + "static/media/Mukunda.c8c9a25c.png";